 
import React from 'react';
import { API_BASE_URL } from '../services/apiServices';

export default function VisitorHeader({ business, visitor, onEdit }) {
  return (
    <div style={headerStyle}>

      {/* Business Branding */}
      <div style={businessStyle}>
        {business?.logo && (
          <img
            src={`${API_BASE_URL}/${business.logo}`}
            alt={business?.name || 'Business logo'}
            style={logoStyle}
          />
        )}

        <div style={businessInfoStyle}>
          <div style={businessNameStyle}>
            {business?.name}
          </div>

          {business?.description && (
            <div style={businessDescriptionStyle}>
              {business.description}
            </div>
          )}
        </div>
      </div>

      {/* Divider */}
      <div style={dividerStyle} />

      {/* Visitor Information */}
      <div style={visitorRowStyle}>
        <div>
          <div style={welcomeStyle}>
            Welcome back 👋
          </div>

          <div style={nameStyle}>
            {visitor?.name}
          </div>

          <div style={phoneStyle}>
            📱 {visitor?.phone}
          </div>
        </div>

        <button onClick={onEdit} style={editButtonStyle}>
          ✏️
        </button>
      </div>

    </div>
  );
}

const headerStyle = {
  background: '#fff',
  borderRadius: '18px',
  padding: '16px',
  marginBottom: '12px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
};

const businessStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

const logoStyle = {
  width: '58px',
  height: '58px',
  borderRadius: '14px',
  objectFit: 'cover',
  border: '1px solid #E5E7EB',
  background: '#F9FAFB',
};

const businessInfoStyle = {
  flex: 1,
  minWidth: 0,
};

const businessNameStyle = {
  fontSize: '19px',
  fontWeight: '800',
  color: '#111827',
  lineHeight: '1.2',
};

const businessDescriptionStyle = {
  fontSize: '12px',
  color: '#6B7280',
  marginTop: '4px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const dividerStyle = {
  height: '1px',
  background: '#F3F4F6',
  margin: '14px 0',
};

const visitorRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const welcomeStyle = {
  fontSize: '12px',
  color: '#6B7280',
};

const nameStyle = {
  fontSize: '18px',
  fontWeight: '700',
  color: '#111827',
  marginTop: '2px',
};

const phoneStyle = {
  fontSize: '13px',
  color: '#6B7280',
  marginTop: '3px',
};

const editButtonStyle = {
  border: 'none',
  background: '#F3F4F6',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  cursor: 'pointer',
  fontSize: '16px',
  flexShrink: 0,
};
 